import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddOfficePayload, OfficeDetails } from 'src/app/Models/office.config';

@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  getAllOffices() {
    return this.http.get<OfficeDetails[]>('Office/GetOffices', { headers: this.headers });
  }

  getActiveOfficeList() {
    return this.http.get<OfficeDetails[]>('Office/GetActiveOffices', { headers: this.headers });
  }

  getOfficeDetailsById(officeId: string) {
    return this.http.get<OfficeDetails[]>(`Office/GetOffice?officeId=${officeId}`, { headers: this.headers });
  }
  
  addOrUpdateOfficeDetails(payload: AddOfficePayload | OfficeDetails) {
    return this.http.post<any>('Office/AddOrUpdateOffice', payload, { headers: this.headers });
  }

  deleteOfficeById(officeId: string) {
    return this.http.get<any>(`Office/DeleteOffice?officeId=${officeId}`, { headers: this.headers });
  }

}
